import LivesNumber from './LivesNumber';

export default LivesNumber;